module.exports = __webpack_public_path__ + "img/riben.1fe9afba.png";